// create entries of a damage - separate file to be sure that all damages has the same format
import _ from 'lodash';

export default function createDamage(damage) {
  let { custom_damage, is_custom, damage_picture, damage_picture2, cost } = damage;
  const { value, element, timestamp, zone } = damage;

  const requiredProperties = [element, value, zone];
  requiredProperties.map((property) => {
    if (property === undefined) throw new Error(`Needs an ${{ property }} on damage`);
    return true;
  });

  // set default values
  if (custom_damage === undefined) custom_damage = '';
  if (is_custom === undefined) is_custom = false;
  if (damage_picture === undefined) damage_picture = null;
  if (damage_picture2 === undefined) damage_picture2 = null;
  if (cost === undefined) cost = null;

  const damageFormalized = {
    cost: _.parseInt(cost, 10),
    custom_damage,
    damage: value,
    damage_picture,
    damage_picture2,
    element,
    is_custom,
    reconditionning: value,
    timestamp,
    zone,
  };
  return damageFormalized;
}
